import { Type } from "./types";

export const STORY_STATS_PRODUCTS = [
  "stories_nba",
  "stories_wnba",
  "stories_mlb",
  "stories_nhl",
  "stories_nfl",
  "stories_soccer",
] as const;

export type StoryStatsType = (typeof STORY_STATS_PRODUCTS)[number];

export const isStoryStatsType = (
  type: string | null | undefined
): type is StoryStatsType =>
  !!type && (STORY_STATS_PRODUCTS as readonly string[]).includes(type);

export const STORY_STATS_PRODUCT_INFO: Record<
  StoryStatsType,
  {
    displayName: string;
    shortName: string;
    monthlyPrice: number;
    description: string;
  }
> = {
  stories_nba: {
    displayName: "StoryStats NBA",
    shortName: "NBA",
    monthlyPrice: 30,
    description: "Pregame, live, and postgame NBA narratives.",
  },
  stories_wnba: {
    displayName: "StoryStats WNBA",
    shortName: "WNBA",
    monthlyPrice: 30,
    description: "Pregame, live, and postgame WNBA narratives.",
  },
  stories_mlb: {
    displayName: "StoryStats MLB",
    shortName: "MLB",
    monthlyPrice: 30,
    description: "Pregame, live, and postgame MLB narratives.",
  },
  stories_nhl: {
    displayName: "StoryStats NHL",
    shortName: "NHL",
    monthlyPrice: 30,
    description: "Pregame, live, and postgame NHL narratives.",
  },
  stories_nfl: {
    displayName: "StoryStats NFL",
    shortName: "NFL",
    monthlyPrice: 30,
    description:
      "Pregame, live, and postgame NFL narratives, including preseason.",
  },
  stories_soccer: {
    displayName: "StoryStats Soccer",
    shortName: "Soccer",
    monthlyPrice: 75,
    description:
      "Pregame, live, and postgame narratives for global soccer.",
  },
};

export const getStoryStatsProductInfo = (type: Type | string) =>
  isStoryStatsType(type) ? STORY_STATS_PRODUCT_INFO[type] : null;

export const getStoryStatsPriceLabel = (type: Type | string) => {
  const info = getStoryStatsProductInfo(type);
  return info ? `$${info.monthlyPrice}/mo` : null;
};

export const getStoryStatsConversionValue = (type: Type | string) =>
  getStoryStatsProductInfo(type)?.monthlyPrice ?? null;
